import { Skeleton } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { ProjectId } from 'api/models';
import { ProjectDetailTabKeys } from 'api/project';
import { PageLoading } from 'components/atoms/loading';
import { BreadCrumbs } from 'components/molecules/project-details/header/breadcrumbs';
import { ProjectTitle } from 'components/molecules/project-details/header/project-title';
import { ProjectDetailTabs } from 'components/molecules/project-details/header/tabs/tabs';
import { ProjectDetailsPageTemplate } from 'components/templates';
import { Content, Layout, Sider } from './project-spaces.styles';
import { ProjectSpacesPageTypes } from './project-spaces.types';

const SkeletonContainer = styled.div`
  padding: var(--spacing-05);
`;

export const ProjectSpacesSkeleton = ({ project }: ProjectSpacesPageTypes) => {
  return (
    <ProjectDetailsPageTemplate
      title={<ProjectTitle project={project} />}
      tabs={
        <ProjectDetailTabs
          projectId={ProjectId(project.projectId)}
          activeTabKey={ProjectDetailTabKeys.Spaces}
        />
      }
      documentTitle={project.projectName}
      breadCrumbs={<BreadCrumbs />}
    >
      <Layout>
        <Sider data-test-id="projects.conversations.sidebar">
          <SkeletonContainer>
            <Skeleton active />
            <Skeleton active />
          </SkeletonContainer>
        </Sider>

        <Content>
          <PageLoading />
        </Content>
      </Layout>
    </ProjectDetailsPageTemplate>
  );
};
